import { Box } from "@mui/material";
import React, { Fragment, memo, useCallback, useRef } from "react";
import useStyles from "../Card/style";

interface IGiftCard {
  data: any;
  id: string;
  imgAltText: string;
  itemDetailRowClassName: string;
  cardInnerData: string;
  cardInnerItemsAltText: string;
  reducer: any;
  dispatchAction: any;
  setLoaded: (value: boolean) => void;
}

const GiftCardList = ({
  data,
  id,
  imgAltText,
  itemDetailRowClassName = "",
  cardInnerData = "innerCards",
  cardInnerItemsAltText,
  reducer,
  dispatchAction,
}: IGiftCard) => {
  const cardRef = useRef<any>(null);
  const styles = useStyles();

  const selectedHandler = (selectedItem: any) => {
    const selectedGiftCards = [...selectedItem.giftCards].find(
      (i: any) => reducer.selectedCardIds?.[selectedItem.companyID] === i.cardID
    );
    const sortedArray = selectedItem?.giftCards.slice();

    dispatchAction({
      type: "selectGift",
      payload: {
        id: selectedItem[id],
        cardID: selectedGiftCards?.cardID || sortedArray?.[0]?.cardID,
      },
    });

    setTimeout(() => {
      if (cardRef?.current) {
        cardRef.current.scrollIntoView({
          behavior: "smooth",
          block: `center`,
          inline: `center`,
        });
      }
    }, 100);
  };

  const preventDefaultHandler = (event: any): void => {
    event.preventDefault();
  };

  const handleActivePrice = (event: React.MouseEvent<HTMLElement>, id: any) => {
    dispatchAction({
      type: "selectCard",
      payload: id,
    });
  };

  const selectItemHandler = (item: any) => {
    dispatchAction({
      type: "selectedCardIds",
      payload: { cardID: reducer.openedCardId, groupID: item.companyID },
    });
  };

  const selectedGift = useCallback(
    (company) => {
      if (reducer.openedGiftCardId) {
        return reducer.openedGiftCardId === company.companyID;
      }
    },
    [reducer?.openedGiftCardId]
  );

  return (
    <React.Fragment>
      {data.map((item: any) => (
        <React.Fragment key={item[id]}>
          <Box
            className={`${
              item?.isLandscape === false
                ? styles.portraitItem
                : styles.landscapeItem
            } ${selectedGift(item) ? "active" : ""}`}
            onClick={() => selectedHandler(item)}
            sx={{
              transition: "2s all ease-in-out",
              animation: "fadeIn 0.9s 1",
              animationFillMode: "both",
              "@keyframes fadeIn": {
                "0% ": {
                  opacity: 0,
                },
                "100%": {
                  opacity: 1,
                },
              },
            }}
          >
            <img
              src={`https://namak.haypost.am${item.mediaPath}`}
              alt={`${imgAltText}`}
              className={styles.w100}
            />
          </Box>
          {reducer?.openedGiftCardId ? (
            <div
              className={`${styles.itemDetailWrapper} ${
                item[id] === reducer?.openedGiftCardId ? "active" : ""
              } item-detailed-wrapper-responsive`}
              style={{
                display:
                  reducer?.openedGiftCardId === item[id] ? "block" : "none",
              }}
              onClick={preventDefaultHandler}
            >
              <div
                className={`${styles.itemDetailRow} ${itemDetailRowClassName}`}
              >
                {item[cardInnerData]?.length > 0 &&
                  item[cardInnerData].map((card: any) => (
                    <Fragment key={card.cardID}>
                      {reducer.openedCardId === card.cardID && (
                        <Fragment>
                          <div
                            className={styles.innerCardItemImgArea}
                            ref={cardRef}
                          >
                            <img
                              src={`https://namak.haypost.am${card.mediaPath}`}
                              alt={cardInnerItemsAltText}
                            />
                          </div>

                          <div className={styles.innerCardItemTextArea}>
                            <p className={styles.innerCardItemTitle}>
                              {/* {card.name} */}
                            </p>
                            <div className={styles.innerCardItemDescription}>
                              {/* {card.description} */}
                            </div>
                          </div>
                          <div
                            className={
                              styles.additionalInnerCardItemDescription
                            }
                          >
                            {/* {card.description} */}
                          </div>
                          <div
                            className={`${styles.buttonsArea} second-buttons-area`}
                          >
                            <button
                              onClick={(event) => selectItemHandler(item)}
                              className="select-btn"
                            >
                              Ավելացնել
                            </button>
                          </div>
                        </Fragment>
                      )}
                    </Fragment>
                  ))}
                <div className={styles.innerCardItemButtonsArea}>
                  <p className={styles.innerCardItemButtonsTitle}>
                    Ընտրիր աջակցության չափը
                  </p>
                  <div className={styles.innerCardItemButtonsRow}>
                    {item[cardInnerData]?.length &&
                      item[cardInnerData].slice().map((card: any) => {
                        return (
                          <button
                            key={card.cardID}
                            className={
                              card.cardID === reducer.openedCardId
                                ? "active"
                                : ""
                            }
                            onClick={(event) => {
                              handleActivePrice(event, card.cardID);
                            }}
                          >
                            {/* {card.cardID === reducer.openedCardId && (
                                <CheckedIcon />
                              )} */}
                            <span className="price">{card.price}֏</span>
                          </button>
                        );
                      })}
                  </div>

                  <div className={styles.buttonsArea}>
                    <button
                      onClick={(event) => selectItemHandler(item)}
                      className="select-btn"
                    >
                      Ավելացնել
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

export default memo(GiftCardList);
